import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import LegacyScrollTransition from 'rlink-transitions/LegacyScrollTransition';

export default function IntroPanelSpaceMarines ({css}) {
  return (
    <LegacyScrollTransition css={css}>
      <div className={css['panel-content']}>
        <h3 className={css.top}>
          <FormattedHTMLMessage
            id="ui.branding.heading.DOW3_SPACE_MARINES_INTRO_PANEL_ANIMATED_TAGLINE"
            defaultMessage={'<span class="{FIRST_CLASSNAME}">Space</span> <span class="{SECOND_CLASSNAME}">Marines</span>'}
            description="Animated tagline appearing on the Space Marines faction page. The two <span>...</span> parts fade-in one after the other and should be roughly equal in size. {FIRST_CLASSNAME} and {SECOND_CLASSNAME} are used to give the different parts their animations and should remain in order."
            values={{
              FIRST_CLASSNAME: css.first,
              SECOND_CLASSNAME: css.second,
            }} />
        </h3>
        <hr className={css.short} />
        <p className={css.top}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_SPACE_MARINES_INTRO_PANEL_BODY_FIRST"
            defaultMessage="Space Marines are genetically engineered warriors on a mission to protect mankind from the gravest of threats across the galaxy."
            description="Paragraph description of the Space Marines faction." />
        </p>
        <p className={css.middle}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_SPACE_MARINES_INTRO_PANEL_BODY_SECOND"
            defaultMessage="Armed with a vast selection of iconic weaponry, clad in suits of intimidating power armour and borne to war aboard deadly vehicles, they are the greatest warriors the galaxy has ever known. They operate as an elite, single-minded strike force."
            description="Paragraph description of the Space Marines faction." />
        </p>
        <p className={css.bottom}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_SPACE_MARINES_INTRO_PANEL_BODY_THIRD"
            defaultMessage="Even with the lower numbers on the front lines, they are a force to be reckoned with."
            description="Paragraph description of the Space Marines faction." />
        </p>
      </div>
    </LegacyScrollTransition>
  );
}

IntroPanelSpaceMarines.propTypes = {
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/IntroPanelSpaceMarines.jsx